import React, {useEffect, useMemo, useRef} from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {Box, Button} from "@mui/material";
import {ReconciliationForm, ReconciliationFormProps} from "~/apps/packages/finance/components/ReconciliationForm";
import {useGetReconciliation} from "~/apps/packages/finance/hooks";
import {useHistory} from "react-router-dom";
import qs from "query-string";
import moment from "moment/moment";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import {Reconciliation} from "~/apps/packages/finance/components/Reconciliation";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";


export const ReconciliationPage = () => {
    const history = useHistory();
    const [getReconciliation, {data, loading, variables}] = useGetReconciliation();

    const title = useMemo(() => {
        if (!loading) {
            const format = value => moment(value).format("MMMM YYYY");
            const monthFrom = format(moment().startOf('months').toDate());
            return `Сверка за ${monthFrom.charAt(0).toUpperCase() + monthFrom.slice(1)}`;
        } else {
            return "Сверка";
        }
    }, [loading]);

    useEffect(() => {
        const getResult = async () => {
            await getReconciliation({
                dateFrom: moment().startOf('months').toDate(),
                dateTo: moment().toDate(),
            });
        }
        getResult();
    }, [])

    const handleGoToDetailsClick = () => {
        history.push('reconciliation/detailing')
    }

    return (
        <TitleLayout title={title}>
            {
                !loading && data && data.balance && data.documents
                    ? <>
                        <Box paddingY={2}>
                            <Reconciliation balance={data?.balance} documents={data?.documents}/>
                        </Box>
                        <Box minHeight="80px"/>
                        <FloatingActions>
                            <Button
                                fullWidth
                                color="primary"
                                onClick={handleGoToDetailsClick}
                            >
                                Запросить детализацию (PDF)
                            </Button>
                        </FloatingActions>
                    </>
                    : <Box pt={2}>
                        <LoadingBox loading={loading}/>
                    </Box>
            }
        </TitleLayout>
    )
}

